import { db } from '../lib/firebase';
import { 
  collection, 
  addDoc, 
  updateDoc, 
  doc, 
  getDocs,
  query,
  where,
  limit,
  serverTimestamp
} from 'firebase/firestore';

const firebaseService = {
  // Créer une nouvelle vente
  async createVente(venteData) {
    console.log('========== DÉBUT CRÉATION VENTE ==========');
    console.log('1. Données reçues:', venteData);
    
    try {
      // Vérifier Firebase
      if (!db) {
        throw new Error('Firebase non initialisé');
      }
      console.log('2. Firebase OK');

      // UTILISER EXACTEMENT LES MÊMES NOMS QUE DANS CINETPAYPAGE
      const documentVente = {
        // Transaction
        transactionId: venteData.transactionId || `TXN_${Date.now()}`,
        montant: venteData.montant || 0,
        dateCreation: serverTimestamp(),
        dateCreationString: new Date().toISOString(),
        
        // Client
        clientNom: venteData.clientNom || venteData.customerName || 'Inconnu',
        clientEmail: venteData.clientEmail || venteData.customerEmail || '',
        clientTelephone: venteData.clientTelephone || venteData.customerPhone || '',
        
        // Client structuré (pour requêtes avancées)
        client: {
          nomComplet: venteData.clientNom || venteData.customerName || '',
          email: venteData.clientEmail || venteData.customerEmail || '',
          telephone: venteData.clientTelephone || venteData.customerPhone || '',
          adresse: venteData.adresseLivraison || '',
          ville: venteData.villeLivraison || '',
          zone: venteData.zoneLivraison || ''
        },
        
        // Pack
        packNom: venteData.packNom || venteData.packName || 'Pack',
        packId: venteData.packId || '',
        quantite: venteData.quantite || venteData.quantity || 1,
        
        // Pack structuré
        pack: {
          id: venteData.packId || '',
          nom: venteData.packNom || venteData.packName || '',
          quantite: venteData.quantite || venteData.quantity || 1,
          prixUnitaire: venteData.prixUnitaire || 0
        },
        
        // Livraison (champs plats)
        adresseLivraison: venteData.adresseLivraison || venteData.deliveryAddress || '',
        villeLivraison: venteData.villeLivraison || venteData.deliveryCity || '',
        zoneLivraison: venteData.zoneLivraison || venteData.deliveryZone || '',
        fraisLivraison: venteData.fraisLivraison || venteData.deliveryCost || 0,
        instructionsLivraison: venteData.instructionsLivraison || venteData.deliveryNotes || '',
        
        // Livraison structurée
        livraison: {
          adresse: venteData.adresseLivraison || venteData.deliveryAddress || '',
          ville: venteData.villeLivraison || venteData.deliveryCity || '',
          zone: venteData.zoneLivraison || venteData.deliveryZone || '',
          frais: venteData.fraisLivraison || venteData.deliveryCost || 0,
          instructions: venteData.instructionsLivraison || venteData.deliveryNotes || ''
        },
        
        // Paiement
        methodePaiement: venteData.methodePaiement || venteData.paymentMethod || 'mobile',
        operateurPaiement: venteData.operateurPaiement || venteData.mobileOperator || null,
        statutPaiement: venteData.statutPaiement || 'PENDING',
        
        // Paiement structuré
        paiement: {
          methode: venteData.methodePaiement || venteData.paymentMethod || 'mobile',
          operateur: venteData.operateurPaiement || venteData.mobileOperator || null,
          statut: venteData.statutPaiement || 'PENDING',
          transactionId: venteData.transactionId || ''
        },
        
        // Totaux
        totaux: {
          sousTotal: (venteData.montant || 0) - (venteData.fraisLivraison || venteData.deliveryCost || 0),
          fraisLivraison: venteData.fraisLivraison || venteData.deliveryCost || 0,
          total: venteData.montant || 0
        },
        
        // Statut
        status: 'PENDING',
        statutCommande: 'EN_ATTENTE_PAIEMENT',
        
        // Métadonnées
        metadata: {
          source: 'web',
          dateCreation: new Date().toISOString()
        },
        
        // Debug
        debug: {
          timestamp: new Date().toISOString(),
          source: 'createVente'
        }
      };

      console.log('3. Document à sauvegarder:', documentVente);

      // Ajout à Firestore
      console.log('4. Ajout à Firestore...');
      const docRef = await addDoc(collection(db, 'ventes'), documentVente);
      
      console.log('5. ✅ Document créé avec ID:', docRef.id);
      console.log('========== FIN CRÉATION VENTE (SUCCÈS) ==========');
      
      return {
        success: true,
        firestoreId: docRef.id,
        transactionId: documentVente.transactionId
      };

    } catch (error) {
      console.log('========== FIN CRÉATION VENTE (ÉCHEC) ==========');
      console.error('❌ ERREUR DÉTAILLÉE:');
      console.error('Code:', error.code);
      console.error('Message:', error.message);
      console.error('Stack:', error.stack);
      
      return {
        success: false,
        error: error.message,
        code: error.code
      };
    }
  },

  // Mettre à jour le statut de paiement
  async updateVenteStatus(transactionId, statut, paymentData = {}) {
    try {
      console.log(`🔄 Recherche vente: ${transactionId} pour mise à jour ${statut}`);
      
      const q = query(
        collection(db, 'ventes'), 
        where('transactionId', '==', transactionId),
        limit(1)
      );
      
      const querySnapshot = await getDocs(q);
      
      if (querySnapshot.empty) {
        console.log('⚠️ Vente non trouvée');
        return { success: false, message: 'Vente non trouvée' };
      }
  
      const venteDoc = querySnapshot.docs[0];
      const venteRef = doc(db, 'ventes', venteDoc.id);
  
      // Préparer les données de mise à jour
      const updateData = {
        statutPaiement: statut,
        status: statut,
        'paiement.statut': statut,
        dateMiseAJour: serverTimestamp()
      };
  
      if (statut === 'SUCCESS' || statut === 'SUCCESS') {
        updateData.statutCommande = 'PAYEE';
        updateData.dateSucces = serverTimestamp();
        updateData['paiement.dateSucces'] = serverTimestamp();
        updateData.referencePaiement = paymentData.reference || null;
        updateData.modePaiement = paymentData.mode || null;
      } else if (statut === 'FAILED') {
        updateData.statutCommande = 'PAIEMENT_ECHOUE';
        updateData.erreurPaiement = paymentData.erreur || 'Paiement échoué';
      }
  
      await updateDoc(venteRef, updateData);
      
      console.log(`✅ Statut vente ${venteDoc.id} mis à jour: ${statut}`);
      
      // Vérifier la mise à jour
      const updatedDoc = await getDocs(query(
        collection(db, 'ventes'), 
        where('transactionId', '==', transactionId),
        limit(1)
      ));
      
      if (!updatedDoc.empty) {
        console.log('📄 Nouveau statut:', updatedDoc.docs[0].data().statutPaiement);
      }
      
      return { 
        success: true, 
        firestoreId: venteDoc.id,
        statut: statut 
      };
      
    } catch (error) {
      console.error('❌ Erreur update:', error);
      return { success: false, error: error.message };
    }
  },

  // Tester la connexion
  async testConnection() {
    try {
      console.log('🔍 Test de connexion Firebase...');
      
      if (!db) {
        throw new Error('Firebase db non initialisé');
      }

      const testCollection = collection(db, 'test_connexion');
      const testDoc = {
        message: 'Test de connexion',
        date: new Date().toISOString(),
        random: Math.random()
      };
      
      console.log('📝 Création document test...');
      const docRef = await addDoc(testCollection, testDoc);
      console.log('✅ Document test créé avec ID:', docRef.id);
      
      return {
        success: true,
        message: 'Connexion Firebase OK',
        docId: docRef.id
      };
      
    } catch (error) {
      console.error('❌ Test échoué:', error);
      return {
        success: false,
        error: error.message
      };
    }
  },

  // Récupérer une vente par transactionId
  async getVenteByTransactionId(transactionId) {
    try {
      const q = query(
        collection(db, 'ventes'), 
        where('transactionId', '==', transactionId),
        limit(1)
      );
      
      const querySnapshot = await getDocs(q);
      
      if (querySnapshot.empty) {
        return { success: false, message: 'Vente non trouvée' };
      }

      const venteDoc = querySnapshot.docs[0];
      
      return {
        success: true,
        firestoreId: venteDoc.id,
        data: venteDoc.data()
      };
      
    } catch (error) {
      console.error('❌ Erreur récupération:', error);
      return { success: false, error: error.message };
    }
  }
};

export default firebaseService;